var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogotype(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 2001,
    height: 2297,
    viewBox: "0 0 2001 2297",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 2001,
    height: 2297,
    rx: 100,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M739.837 444.195C576.574 444.195 444.223 576.338 444.223 739.343V1770.88C444.223 1831.51 513.383 1866.26 562.151 1830.15L720.227 1716.55C732.962 1707.12 748.397 1702.02 764.252 1702.02H1109.36C1354.25 1702.02 1552.78 1503.81 1552.78 1259.3V886.918C1552.78 642.409 1354.25 444.195 1109.36 444.195H739.837ZM888.324 739.955C806.442 739.955 740.064 806.163 740.064 887.835V1035.71H888.324H962.455C1044.34 1035.71 1110.72 969.507 1110.72 887.835C1110.72 806.163 1044.34 739.955 962.455 739.955H888.324ZM1109.26 1110.5H887.741H740.064V1258.38C740.064 1340.06 806.181 1406.26 887.741 1406.26H1109.26C1190.82 1406.26 1256.94 1340.06 1256.94 1258.38C1256.94 1176.71 1190.82 1110.5 1109.26 1110.5Z",
    fill: "#FFC929"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogotype);
export default __webpack_public_path__ + "static/media/Logotype.cf9c37bfac0a53bb99b49f19b0bce8d2.svg";
export { ForwardRef as ReactComponent };